import { nowLocalMoment } from '../../utils/appointments/dateFilter';
import { createAction } from '../../utils/redux/createAction';
import { APPOINTMENT_PROGRESS_TYPES } from './progress-types';

const actionsScope = 'appointment-form/filters';

export const APPOINTMENT_FILTER_TYPES = {
  SET_DATE: `${actionsScope}/set-date`,
  SET_LOCATION: `${actionsScope}/set-location`,
};

export const appointmentFilterActions = {
  setDate: createAction(APPOINTMENT_FILTER_TYPES.SET_DATE),
  setLocation: createAction(APPOINTMENT_FILTER_TYPES.SET_LOCATION),
};

const initialState = {
  date: nowLocalMoment.toISOString(true),
  location: [],
};

export default function filters(state = initialState, { type, payload }) {
  switch (type) {
    case APPOINTMENT_FILTER_TYPES.SET_DATE: {
      return { ...state, date: payload };
    }

    case APPOINTMENT_FILTER_TYPES.SET_LOCATION: {
      return { ...state, location: payload };
    }

    case APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/filters.js